import { tenantSettings } from '$lib/domain/tenantSettings/tenantSettings'
import { get } from 'svelte/store'

export function title(title: string) {
	return `${title} – ${get(tenantSettings)?.tenantDetail?.name}`
}
